import { yup } from '@framework/validation/initYup.ts';
import { BooleanConditionSchema } from '../../inputs/expressions-editor/conditions/BooleanConditionSchema.ts';
import { WidgetDirectivesSchema } from '../directives/WidgetDirectivesSchema.ts';
import { type IBaseWidget } from './IBaseWidget.ts';
import { BaseLayoutSchema } from './repository/common/BaseLayoutSchema.ts';
import { WidgetType } from './Widget.ts';

export const CommonBaseWidgetSchema: yup.ObjectSchema<IBaseWidget> = yup
  .object({
    id: yup.string().required(),
    order: yup.number().required().default(0),
    path: yup.array().required().default([]),

    type: yup.string().oneOfEnum(WidgetType).required(), // Qui `oneOfEnum` è corretto perché ulteriori tipi di widget sovrascrivono il validatore per `type` con `.exact`

    // Layout
    layout: BaseLayoutSchema,

    fromVirtualId: yup.string(),

    // Direttive
    directives: WidgetDirectivesSchema,
    // Regole di visibilità
    visible: BooleanConditionSchema,
    enabled: BooleanConditionSchema,
  })
  .required()
  .noUnknown();
